import { render, staticRenderFns } from "./StatsView.vue?vue&type=template&id=73841b42&"
import script from "./StatsView.vue?vue&type=script&lang=js&"
export * from "./StatsView.vue?vue&type=script&lang=js&"
import style0 from "./StatsView.vue?vue&type=style&index=0&id=73841b42&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports